/**
 * This script is deployed to cloudfare R2 CDN along with the actual
 * chatbot.js web component files. Since similar code snippet is too
 * complex to customers to copy & paste into GTM, we've created this
 * simple script that does the job.
 *
 * User then only copies & pastes this script into their website:
 *
 * <script async src="https://loader.kanbu.ai/v0/embed.js" data-kanbu-agent-id="123"></script>
 *
 * We than extract the agent ID from the data-kanbu-agent-id attribute,
 * remove all existing chatbot web components with a different agent ID,
 * load the chatbot.js script and create the chatbot web component.
 */
(() => {
  // Get the agent ID from the script tag data attribute
  const kanbuAgentId = (
    document.querySelector('script[data-kanbu-agent-id]') as HTMLScriptElement
  )?.dataset?.kanbuAgentId;

  // Bail when not available
  if (!kanbuAgentId) {
    return;
  }

  // Check if the web component is already present
  if (document.querySelector(`kanbu-chatbot[chat="${kanbuAgentId}"]`)) {
    return;
  }

  // Get all existing chatbot web components
  const existingChatbots = document.querySelectorAll('kanbu-chatbot');

  // Remove existing chatbots if the ID doesn't match
  existingChatbots.forEach(function (chatbot) {
    if (chatbot.getAttribute('chat') !== kanbuAgentId) {
      chatbot.remove();
    }
  });

  // Helper for creating a new chatbot web component
  const createChatbot = () => {
    const chatbotElement = document.createElement('kanbu-chatbot');
    chatbotElement.setAttribute('chat', kanbuAgentId);
    document.body.append(chatbotElement);
  };

  // Check if the chatbot.js script is already present
  if (
    document.querySelector(
      'script[src="https://loader.kanbu.ai/v0/chatbot.js"]',
    )
  ) {
    // Just create the chatbot web component
    createChatbot();
  } else {
    /**
     * Add chatbot.js script to the document,
     * then create the chatbot web component.
     */
    const script = document.createElement('script');
    script.src = 'https://loader.kanbu.ai/v0/chatbot.js';
    script.type = 'module';
    script.async = true;

    script.addEventListener('load', function () {
      createChatbot();
    });

    document.body.append(script);
  }
})();
